import { css } from 'styled-components';
import { MODAL_TRANSITION_DURATION, MODAL_VEIL_Z_INDEX, MODAL_Z_INDEX, } from './tokens';
//
// Tokens
//
export const CFBaseModalWrapperTokens = {};
//
// Helpers
//
export const CFBaseModalWrapperHelpers = {
    rootCSSTransitions: ({ enterFrom, exitTo, transitionState, }) => {
        switch (transitionState) {
            case 'entering':
                return css `
          display: flex;
          opacity: 0;
          ${CFBaseModalWrapperUtils.transformDirection(enterFrom)}
        `;
            case 'entered':
                return css `
          transform: translateX(0) translateY(0);
          opacity: 1;
        `;
            case 'exiting':
                return css `
          opacity: 0;
          ${CFBaseModalWrapperUtils.transformDirection(exitTo)}
        `;
            case 'exited':
                return css `
          display: none;
          opacity: 0;
          ${CFBaseModalWrapperUtils.transformDirection(exitTo)}
        `;
        }
    },
};
//
// Element Utilities
//
export const CFBaseModalWrapperUtils = {
    transformDirection: (dir) => {
        switch (dir) {
            case 'top':
                return css `
          transform: translateX(0) translateY(-100%);
        `;
            case 'right':
                return css `
          transform: translateX(100%) translateY(0);
        `;
            case 'left':
                return css `
          transform: translateX(-100%) translateY(0);
        `;
            case 'bottom':
            default:
                return css `
          transform: translateX(0) translateY(100%);
        `;
        }
    },
};
//
// Element Styles
//
export const CFBaseModalWrapperStyles = {
    DismissHitspace: css `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: ${MODAL_VEIL_Z_INDEX};
    background-color: transparent;
    border: 0;
    outline: 0;
  `,
    Root: css `
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: ${MODAL_Z_INDEX};
  `,
    RootWeb: css `
    transition-duration: ${MODAL_TRANSITION_DURATION}ms;
    transition-timing-function: ease-in-out;
    ${CFBaseModalWrapperHelpers.rootCSSTransitions};
  `,
};
